<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Lote</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div v-if="plot" class="container-fluid mt--6">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <plot-data :plot="plot"></plot-data>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="table-responsive">
            <plot-permission-table :plot="plot" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import PlotPermissionTable from '@/views/PlotPermissions/Show/PermissionTable.vue';
import PlotData from '@/views/PlotPermissions/Show/PlotData.vue';

export default {
  name: 'PlotPermissionsShow',
  components: {
    PlotPermissionTable,
    RouteBreadCrumb,
    PlotData,
  },

  data() {
    return {
      plot: null,
    };
  },

  mounted() {
    this.fetchPlot(this.$route.params.id);
  },

  methods: {
    fetchPlot(plotId) {
      this.$services
        .resource('plots')
        .show(plotId, { include: ['field.producer.distributor', 'campaign'] })
        .then((res) => res.data.data)
        .then((plot) => {
          this.plot = plot;
        });
    },
  },
};
</script>

<style scoped>
div.el-table .el-table__header .cell,
::v-deep div.el-table .el-table__row .cell {
  word-break: keep-all;
}
</style>
